'use client';

import { Button } from '@wwe-portal/ui/components/button';
import {
  createPortableDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { OutStockClubCoinDialog } from '@wwe-portal/ui/features/club-store/dialog';
import { useRouter } from 'next/navigation';
import { FAQ_KEYS } from '@wwe-portal/web/providers/queries/subscription';

export const NotEnoughClubCoinDialog = createPortableDialog(() => {
  const modal = usePortableDialog();
  const router = useRouter();
  return (
    <OutStockClubCoinDialog
      open={modal.visible}
      onClose={modal.remove}
      data={{
        actionElement: (
          <div className="flex w-full justify-center">
            <Button
              className="w-full max-w-[178px] truncate text-xs font-semibold"
              variant="orange"
              onClick={() => {
                router.push(
                  `/subscription?faq-item=${FAQ_KEYS.HOW_TO_EARN_CLUB_COINS}`
                );
                modal.remove();
              }}
            >
              GO TO FAQ
            </Button>
          </div>
        ),
      }}
    />
  );
});
